export default `
  cityInfo {
    id
    currencyIsoCode
    cityName(locale: $locale)
  }
`;
